// src/services/accordService.js
import api from './api';

const accordService = {
  // ── Investor endpoints ─────────────────────────────────────────────────────

  proposeAccord: (payload) =>
    api.post('/investor/accords', payload),

  listMyAccords: (status) =>
    api.get('/investor/accords', {
      params: status ? { status } : {},
    }),

  cancelAccord: (accordId) =>
    api.put(`/investor/accords/${accordId}/cancel`),

  terminateAccord: (accordId) =>
    api.put(`/investor/accords/${accordId}/terminate`),

  signAccord: (accordId) =>
    api.put(`/investor/accords/${accordId}/sign`),

  // ── Manager endpoints ──────────────────────────────────────────────────────

  listManagerAccords: (status) =>
    api.get('/manager/accords', {
      params: status ? { status } : {},
    }),

  approveAccord: (accordId) =>
    api.put(`/manager/accords/${accordId}/approve`),

  rejectAccord: (accordId) =>
    api.put(`/manager/accords/${accordId}/reject`),

  terminateManagerAccord: (accordId) =>
    api.put(`/manager/accords/${accordId}/terminate`),
};

export default accordService;
